"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPassStatusColor = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const PassStatus_1 = __importDefault(require("./PassStatus"));
const getPassStatusColor = status => {
    switch (status) {
        case PassStatus_1.default.PASS:
            return lib_palette_1.default.Greeny;
        case PassStatus_1.default.FAIL:
            return lib_palette_1.default.TimelineRed;
        case PassStatus_1.default.UNDETERMINED:
            return lib_palette_1.default.GreyBlue;
        default:
            return lib_palette_1.default.GreyBlue;
    }
};
exports.getPassStatusColor = getPassStatusColor;
exports.default = exports.getPassStatusColor;
